<template>
  <el-container class="access-request-page">
    <el-header height="50px" class="page-header">
      <div class="header-title">验证消息</div>
    </el-header>
    <el-main class="page-main">
      <div v-if="loading" class="empty-state">
        <i class="el-icon-loading" style="font-size:24px"></i>
      </div>
      <div v-else-if="requests.length === 0" class="empty-state">
        <p>暂无新的验证消息</p>
      </div>
      <div v-else class="req-list">
        <div v-for="req in requests" :key="req.id" class="req-card">
          <head-image :url="req.userHeadImage" :name="req.userNickName || ''" :size="48"></head-image>
          <div class="req-name">{{ req.userNickName || '用户' + req.userId }}</div>
          <div class="req-desc" v-if="req.type === 'FRIEND'">请求添加你为好友</div>
          <div class="req-desc" v-else>申请加入「{{ req.targetName }}」</div>
          <div class="req-source" v-if="req.agentName">通过智能体「{{ req.agentName }}」</div>
          <div class="req-btns" v-if="req.status === 'PENDING'">
            <el-button type="primary" size="small" @click="approve(req)">同意</el-button>
            <el-button size="small" @click="reject(req)">拒绝</el-button>
          </div>
          <div class="req-result" v-else>
            <span :class="req.status === 'APPROVED' ? 'green' : 'gray'">
              {{ req.status === 'APPROVED' ? '已添加' : '已拒绝' }}
            </span>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';

export default {
  components: { HeadImage },
  data() {
    return { requests: [], loading: false };
  },
  mounted() { this.loadRequests(); },
  methods: {
    async loadRequests() {
      this.loading = true;
      try {
        const res = await this.$http({ url: '/access-request/pending', method: 'get' });
        this.requests = res || [];
      } catch (e) { this.requests = []; }
      this.loading = false;
    },
    async approve(req) {
      try {
        await this.$http({ url: `/access-request/${req.id}/approve`, method: 'post' });
        this.$message.success('已同意');
        req.status = 'APPROVED';
        this.$emit('approved');
      } catch (e) { this.$message.error(e.message || '操作失败'); }
    },
    async reject(req) {
      try {
        await this.$http({ url: `/access-request/${req.id}/reject`, method: 'post' });
        req.status = 'REJECTED';
      } catch (e) { this.$message.error(e.message || '操作失败'); }
    }
  }
};
</script>

<style scoped>
.access-request-page {
  height: 100%;
}
.page-header {
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  padding: 0 20px;
}
.header-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
}
.page-main {
  padding: 24px !important;
  background: #f5f5f5;
  overflow-y: auto;
}
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #bbb;
  font-size: 14px;
}
.req-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
}
.req-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px 20px;
  width: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 1px 6px rgba(0,0,0,0.06);
  transition: box-shadow 0.2s;
}
.req-card:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
}
.req-name {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  margin-top: 10px;
}
.req-desc {
  font-size: 13px;
  color: #999;
  margin-top: 6px;
}
.req-source {
  font-size: 12px;
  color: #409eff;
  margin-top: 4px;
}
.req-btns {
  margin-top: 14px;
  display: flex;
  gap: 8px;
}
.req-result {
  margin-top: 14px;
  font-size: 13px;
}
.green { color: #67c23a; }
.gray { color: #ccc; }
</style>
